// Client-side Excel export for the Tender Opening Detail tabs.
//
// Like the Planning/Procurement modules, export is "against the data currently
// shown" — we build the workbook in the browser from the on-screen rows using
// the already-installed `xlsx` package (no server round-trip while dummy).

import * as XLSX from 'xlsx';
import { formatDate } from '../tenderOpeningFormatters';

const triggerDownload = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

// Sending Request HPS tab — lampiran Nota Dinas Permintaan HPS Alpha & Freight
// Cost (desain acuan): workbook 2 sheet — (1) matriks Crude × Quantity yang
// dicentang di layar, (2) Cargo Requirement read-only.
export const exportHpsExcel = (
  { cargo, qtyCols = [], checked = {} },
  cargos = [],
  procId
) => {
  const matrixRows = (cargo?.crudes || []).map((cr, idx) => {
    const row = { No: idx + 1, Crude: cr.crudeName };
    qtyCols.forEach(q => {
      row[q] = checked[`${cr.id}|${q}`] ? 'Yes' : '';
    });
    return row;
  });
  const cargoRows = cargos.map(c => ({
    'Cargo Type': c.cargoType,
    'Parcel Size (Kbbl)': c.volume ?? '',
    'OT (%)': c.ot != null ? `(±) ${c.ot}% ${c.otOption || ''}`.trim() : '',
    Incoterms: (c.incoterms || []).join('/'),
    'Incoterms Notes': c.incotermsNotes || '',
    Delivery: `${c.plant} ${c.unit}`,
    DDR: `${formatDate(c.ddrFrom)} s/d ${formatDate(c.ddrTo)}`,
    'DDR Notes': c.ddrNotes || '',
  }));

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(
    wb,
    XLSX.utils.json_to_sheet(matrixRows),
    'HPS Quantity'
  );
  XLSX.utils.book_append_sheet(
    wb,
    XLSX.utils.json_to_sheet(cargoRows),
    'Cargo Requirement'
  );
  const out = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  triggerDownload(
    new Blob([out], { type: 'application/octet-stream' }),
    `tender-opening-hps_${procId}.xlsx`
  );
};
